require('./cardCancelDeferPurchaseWizard.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

//@components
const CardCancelDeferPurchaseStep1 = require('./cardCancelDeferPurchaseStep1');
const CardCancelDeferPurchaseStep2 = require('./cardCancelDeferPurchaseStep2');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

//@utilities
const currencyHelper = require('utilities/currencyHelper');

class cardCancelDeferPurchaseWizard extends React.Component {
    constructor(props) {
        super(props);
        this.buildInformativeList = this.buildInformativeList.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.state = {
            showErrorPopup: false
        }
    }

    handleValidation(step) {
        const {
            immAccounts,
            immCard,
            immCardCancelDeferPurchase,
            onValidateStep,
        } = this.props;
        if (step == 1) {
            if (immCardCancelDeferPurchase.get('fetchSuccess')) {
                const associatedAccountNumber = immCard.get('associatedAccount');
                const originAccount = immAccounts.get('byId').find(function (account) {
                    return account.get('contractNumber').substr(-4) === associatedAccountNumber.substr(-4);
                });
                const associatedAccountBalance = originAccount.getIn(['balances', 'availableBalance', 'amount'], 0);
                const cancelDeferPurchaseData = immCardCancelDeferPurchase.get('cancelDeferPurchaseData');
                const totalAmountToBePaid = (cancelDeferPurchaseData.getIn(['importeCapitalPend', 'importe']) + cancelDeferPurchaseData.getIn(['importeInteres', 'importe']));
                if (associatedAccountBalance <= totalAmountToBePaid) {
                    this.setState({
                        showErrorPopup: true
                    })
                }

                else {
                    onValidateStep(step);
                }
            }
        }
        else {
            onValidateStep(step);
        }
    }

    handleCancel() {
        this.props.history.push(`/myprofile/cards/${this.props.cardId}/movements`)
    }

    buildInformativeList() {
        const {
            cardId,
            immAccounts,
            immCard,
            immCardCancelDeferPurchase,
            immCardsTransactions,
            movementId
        } = this.props;
        let informativeList;

        if (immCardCancelDeferPurchase.get('fetchSuccess')) {
            const immMovement = immCardsTransactions.getIn([cardId, 'byId', movementId]);
            const currency = currencyHelper.formatCurrency(immMovement.getIn(['import', 'currency']));
            const cancelDeferPurchaseData = immCardCancelDeferPurchase.get('cancelDeferPurchaseData');
            const pendingCapitalTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_pendingAmount')
            const pendingInterestTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_interestOnAmount');
            const totalAmountToBePaidTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_totalAmountToBePaid');
            const associatedAccountTitle = formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_accountAssociated');

            const pendingCapitalAmount = cancelDeferPurchaseData.getIn(['importeCapitalPend', 'importe']);
            const pendingCapitalAmountFormatted = currencyHelper.formatAmount(pendingCapitalAmount) + ' ' + currency;

            const pendingInterestAmount = cancelDeferPurchaseData.getIn(['importeInteres', 'importe']);
            const pendingInterestAmountFormatted = currencyHelper.formatAmount(pendingInterestAmount) + ' ' + currency;

            const totalAmountToBePaid = (cancelDeferPurchaseData.getIn(['importeCapitalPend', 'importe']) + cancelDeferPurchaseData.getIn(['importeInteres', 'importe']));
            const totalAmountToBePaidFormatted = currencyHelper.formatAmount(totalAmountToBePaid) + ' ' + currency;

            const associatedAccountNumber = immCard.get('associatedAccount');
            const originAccount = immAccounts.get('byId').find(function (account) {
                return account.get('contractNumber').substr(-4) === associatedAccountNumber.substr(-4);
            });
            const originAccountAlias = originAccount && (originAccount.get('alias'));
            const associatedAccountNumberText = `${originAccountAlias} ...${associatedAccountNumber.substr(-4)}`;

            informativeList = (
                <OKInformativeList>
                    <OKInformativeListItem title={pendingCapitalTitle} bodyText={pendingCapitalAmountFormatted} />
                    <OKInformativeListItem title={pendingInterestTitle} bodyText={pendingInterestAmountFormatted} />
                    <OKInformativeListItem className="card-cancel-defer-purchase-wizard__bold" title={totalAmountToBePaidTitle} bodyText={totalAmountToBePaidFormatted} />
                    <OKInformativeListItem title={associatedAccountTitle} bodyText={associatedAccountNumberText} />
                </OKInformativeList>
            )
        }

        else if (immCardCancelDeferPurchase.get('isFetching')) {
            informativeList = <LoadingSection />
        }

        return informativeList;
    }

    render() {
        const {
            getCancelDeferPurchaseInfo,
            immCard,
            immCardCancelDeferPurchase,
            immCardMovementInstallmentsChart,
            immCardsTransactions,
            movementId,
            onFinish,
            onWillCancel,
            reset,
            setVisibleStep,
        } = this.props;
        const visibleStep = immCardCancelDeferPurchase.get('visibleStep');
        const immSteps = immCardCancelDeferPurchase.get('steps');
        const actions = {
            cancel: this.handleCancel,
            finish: onFinish,
            setVisibleStep,
            setWillCancel: onWillCancel,
            validateStep: this.handleValidation,
        };
        let informativeList = this.buildInformativeList();
        let openErrorPopup = false;
        const errorPopupMessage = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_errorDescription" />);
        const errorPopupTitle = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_errorPopupTitle" />);
        const primaryButtonText = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_errorPopupPrimarybutton" />);
        const secondaryButtonText = (<FormattedText value="cardCancelDeferPurchase-cardCancelDeferPurchase_errorPopupSecondarybutton" />);
        const finalButtonText = 'cardCancelDeferPurchase-cardCancelDeferPurchase_finalButton';

        return (
            <div>
                <OKModal
                    description={errorPopupMessage}
                    descriptionAlignment="left"
                    footerType="action"
                    isOpen={this.state.showErrorPopup}
                    onCloseCallback={this.handleCancel}
                    onPrimaryButtonClick={this.handleCancel}
                    onSecondaryButtonClick={this.handleCancel}
                    primaryButtonText={primaryButtonText}
                    secondaryButtonText={secondaryButtonText}
                    shouldCloseOnOverlayClick={false}
                    title={errorPopupTitle}
                    titleAlignment="left"
                />
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-md-12">
                                <Wizard
                                    actions={actions}
                                    immSteps={immSteps}
                                    stepsAmount={immSteps.size}
                                    visibleStep={visibleStep}
                                    wizardClass="card-cancel-defer-purchase-wizard"
                                >
                                    <WizardStep
                                        actions={actions}
                                        cancelButton={true}
                                        nextButton={true}
                                        position="first"
                                    >
                                        <CardCancelDeferPurchaseStep1
                                            getCancelDeferPurchaseInfo={getCancelDeferPurchaseInfo}
                                            immCardCancelDeferPurchase={immCardCancelDeferPurchase}
                                            immCardMovementInstallmentsChart={immCardMovementInstallmentsChart}
                                            informativeList={informativeList}
                                        />
                                    </WizardStep>
                                    <WizardStep
                                        finalButtonDisabled={immCardCancelDeferPurchase.get('isLoading')}
                                        finishButton={true}
                                        immFinalButton={finalButtonText}
                                        actions={actions}
                                        cancelButton={true}
                                        nextButton={true}
                                        position="last"
                                    >
                                        <CardCancelDeferPurchaseStep2
                                            immCard={immCard}
                                            immCardCancelDeferPurchase={immCardCancelDeferPurchase}
                                            immCardsTransactions={immCardsTransactions}
                                            informativeList={informativeList}
                                            movementId={movementId}
                                            onHandleToggleModal={this.handleCancel}
                                            showErrorPopup={openErrorPopup}
                                            reset={reset}
                                        />
                                    </WizardStep>
                                </Wizard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

cardCancelDeferPurchaseWizard.propTypes = {
    history: PropTypes.object.isRequired,
    cardId: PropTypes.object.isRequired,
    getCancelDeferPurchaseInfo: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCancelDeferPurchase: PropTypes.object.isRequired,
    immCardMovementInstallmentsChart: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    movementId: PropTypes.object.isRequired,
    onChangeAcceptedInstructions: PropTypes.func.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
};

module.exports = withRouter(cardCancelDeferPurchaseWizard);
